import { render, staticRenderFns } from "./TrTestMulti.vue?vue&type=template&id=6b9b3a05&scoped=true&"
import script from "./TrTestMulti.vue?vue&type=script&lang=js&"
export * from "./TrTestMulti.vue?vue&type=script&lang=js&"
import style0 from "./TrTestMulti.vue?vue&type=style&index=0&id=6b9b3a05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9b3a05",
  null
  
)

export default component.exports